import { z } from 'zod';

export type OneTimeCodeQuery = z.infer<typeof oneTimeCodeQuerySchema>;

export const oneTimeCodeQuerySchema = z.object({
  token: z.string(),
});
